export enum CostBasisFallbackBase {
  EMPTY = '',
  FIFO = 'FIFO',
}

export enum SpecIDFallback {
  FIFO = 'FIFO',
  CANCEL = 'CANCEL',
  EMPTY = '',
}

export enum AvgCostConversion {
  EMPTY = '',
  FIFO = 'FIFO',
  AVGCOST = 'AvgCost',
}

export enum MinTaxConversion {
  EMPTY = '',
  FIFO = 'FIFO',
  MINTAX = 'MinTax',
}
